var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7902 8.31006L9.99999 4.6826L8.20973 8.31006L4.20659 8.89175L7.10329 11.7153L6.41947 15.7023L9.99999 13.8199L13.5805 15.7023L12.8967 11.7153L15.7934 8.89175L11.7902 8.31006ZM7.10295 6.78672L2.29595 7.48521C1.61244 7.58453 1.33951 8.42451 1.83411 8.90662L5.31249 12.2972L4.49135 17.0848C4.37459 17.7655 5.08912 18.2847 5.70048 17.9633L9.99999 15.7029L14.2995 17.9633C14.9108 18.2847 15.6254 17.7655 15.5086 17.0848L14.6875 12.2972L18.1659 8.90662C18.6605 8.42451 18.3875 7.58453 17.704 7.48521L12.897 6.78672L10.7473 2.43084C10.4416 1.81147 9.55838 1.81147 9.25271 2.43084L7.10295 6.78672Z",
    fill: "#333843"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.860bf1b3620f7153892e348875cc5ff9.svg";
export { ForwardRef as ReactComponent };